<script lang="ts">
	import Chip, { Text } from '@smui/chips/styled';
	export let mixList = [];
</script>

<div class="wrap">
	{#each mixList as element}
		{#if element === '(' || element === ')' || element === 'or' || element === 'and'}
			<div>
				{element}
			</div>
		{:else}
			<Chip chip="mixChip">
				<Text>{element}</Text>
			</Chip>
		{/if}
	{/each}
</div>

<style>
	.wrap {
		display: flex;
		flex-wrap: wrap;
		align-items: baseline;
		padding: 3px 0 3px 8px;
	}

	.wrap > div {
		margin-right: 6px;
	}
</style>
